export default "__VITE_ASSET__DocTxCaX__"